if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url || this.dataset.loaded === 'true') {
          return;
        }

        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.status);
            }

            return response.text();
          })
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const recommendations = html.querySelector('[data-product-recommendations]');

            if (!recommendations || !recommendations.innerHTML.trim() || recommendations.querySelector('[data-recommendations-placeholder]')) {
              this.remove();
              return;
            }

            this.setAttribute('data-loading-complete', '');
            this.innerHTML = recommendations.innerHTML;
            this.dataset.loaded = 'true';
            requestAnimationFrame(() => this.removeAttribute('data-loading-complete'));
          })
          .catch(() => {
            this.remove();
          });
      }
    },
  );
}
